module.exports = __webpack_public_path__ + "img/vektor.261b7535.svg";